export default __webpack_public_path__ + "static/media/pusat-pembelajaran-terbimbing-icon.2fa1a15b.webp";